<template>
    <div class="hub-profile">
        <CreateNewHubModal :show_new_hub.sync="modals.show_new_hub"/>
        <base-header class="pb-6">
            <b-row align-v="center" class="py-3">
                <b-col cols="6">
                    <p class="font-weight-normal mb-0 text-muted">Commission</p>
                    <h2 class="listing-title d-inline-block mb-0">Hub</h2>
                </b-col>
                <b-col cols="6" class="text-right ">
                    <b-button v-show="backButton" variant="primary" icon size="sm" @click="close()">
                        <span class="btn-inner--text">Back / Close</span>
                    </b-button>
                    <b-button variant="primary" class="btn-header" @click="modals.show_new_hub = true">Create New</b-button>
                </b-col>
            </b-row>
        </base-header>
        <b-container fluid class="mt--6">
            <hub-listing-table></hub-listing-table>
        </b-container>
    </div>
</template>
<script>
import HubListingTable from '@/views/Commission/Hub/HubListingTable'
import CreateNewHubModal from '@/views/Commission/Hub/HubProfile/HubModals/CreateNewHubModal'
export default {
    components: {
        HubListingTable,
        CreateNewHubModal
    },
    data() {
        return {
            modals: {
                show_new_hub: false
            },  
            backButton: false,
        };
    },
    created() {
        if(this.$route.params.token)
        {
            this.backButton = true;
        }
    },
    methods: {
        close() {
            if(this.$route.params.token)
            {
                // window.location.href = "https://sas.imortgage2u.com/portal/initialSettlement/proposal/"+this.$route.params.proposal_id;
                window.history.back();
                window.close();
            }
            else
            {
                this.$router.back();
            }
        }
    }
}
</script>